import { render, staticRenderFns } from "./CardRequestUsers.vue?vue&type=template&id=23d9e48e&scoped=true&"
import script from "./CardRequestUsers.vue?vue&type=script&lang=js&"
export * from "./CardRequestUsers.vue?vue&type=script&lang=js&"
import style0 from "./CardRequestUsers.vue?vue&type=style&index=0&id=23d9e48e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d9e48e",
  null
  
)

export default component.exports